import { instance } from '@/services/avik-api-gateway'
import { TrackCount } from './getTrackCount'

export const createTrackCount = async (
  trackCounts: TrackCount[]
): Promise<void> => {
  for (const trackCount of trackCounts) {
    await instance.post(`/graph/track-count`, trackCount)
  }
}
